<span #tooltip="matTooltip" [matTooltip]="text" [matTooltipDisabled]="onClick || disabled" (click)="displayTooltip(true)" (mouseleave)="displayTooltip(false)" [attr.matTooltipPosition]="!positionAtOrigin ? position : undefined" [matTooltipPositionAtOrigin]="positionAtOrigin" [matTooltipShowDelay]="showDelay">
	<ng-content />
</span>
